import { LayoutCreatorHeaderCell } from './LayoutCreatorHeaderCell';
import { LAYOUT_CREATOR_ID } from './layout-creator-utils';

export const layoutCreatorColumn = {
  dataIndex: LAYOUT_CREATOR_ID,
  width: 187,
  title: <LayoutCreatorHeaderCell />,
};
